var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"content-wrapper"},[_c('ReceiptPreview',{ref:"Receipt",attrs:{"containerTarget":"#print","receiptData":_vm.receipt,"patientData":_vm.patient}}),_c('div',{staticClass:"w-100 d-flex"},[_c('button',{staticClass:"my-5 mx-auto",attrs:{"type":"button"},on:{"click":_vm.printReceipt}},[_vm._v(" Try to Print ")])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }